import { NgModule } from "@angular/core";
import { AuthRoutingModule } from "./auth-routing.module";
import { ResponseMessageService } from "./services/response-message.service";

@NgModule({
    declarations: [],
    imports: [AuthRoutingModule],
    providers: [ResponseMessageService],
})
export class AuthModule {}
